const config = {
  // BASE_URL: "http://localhost:4000",
  BASE_URL: "https://api.8080.cl",
  LINKED_MONITOR: process.env.REACT_APP_LINKED_MONITOR,
  SUB_DOMAIN_PREFIX: window.location.hostname.split('.')[0] === 'localhost' ? 'grua' : window.location.hostname.split('.')[0],
  RTL_LANGUAGES: ['ar', 'he']
  // BASE_URL: "https://backend-8080.herokuapp.com",
};
export default config;
